// Pages merged into others by the information architecture
// (docs/design/INFORMATION_ARCHITECTURE.md). Old links keep working:
// `:param` segments are copied and the query string and hash are preserved
// (PreservingRedirect). Old /admin/* routes are listed with the
// Organization sections in components/organization/sections.js.
export const LEGACY_ROUTE_REDIRECTS = [
  ["/settings/system", "/organization/system"],
  ["/pipeline", "/deals?view=board"],
  ["/pipeline/:id", "/deals?view=board&pipeline=:id"],
  ["/lists", "/campaigns?tab=lists"],
  ["/customers", "/companies?view=customers"],
  ["/customers/:id", "/companies?view=customers"],
  ["/campaign-view/:campaignId", "/campaigns/:campaignId"],
  // Organization and Settings pages folded into others (they only said a
  // feature was missing, or repeated another page).
  ["/organization/dialing/campaigns", "/organization/dialing/defaults"],
  ["/organization/dialing/calling", "/organization/telephony/asterisk"],
  ["/organization/people/access", "/organization/people/roles"],
  // The RTP engine is platform-wide (super admin), not organization telephony.
  ["/organization/telephony/rtp", "/organization/platform/rtp"],
  ["/organization/system/logs", "/organization/audit"],
  ["/settings/notifications", "/settings/preferences"],
];
